export interface ContractorDocument {
  name: string,
  uploaded: string,
  extension: string
}
